var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "25px",
    viewBox: "0 0 10 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pal",
    transform: "translate(5.000000, 12.500000) rotate(-270.000000) translate(-5.000000, -12.500000) translate(-7.000000, 8.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.555,0 C22.01,0 24,2.015 24,4.5 C24,6.985 22.01,9 19.555,9 C18.4609058,8.99624495 17.4078319,8.58314889 16.603,7.842 C15.654651,6.98968771 15.1123974,5.77506863 15.111,4.5 C15.111,3.494 15.448,2.574 15.999,1.824 C16.179,1.581 16.381,1.36 16.603,1.158 C17.4078319,0.416851113 18.4609058,0.00375505408 19.555,0 Z M4.444,0 C5.849,0 7.088,0.673 7.902,1.705 C7.38807882,2.54660063 7.11451318,3.51289947 7.111,4.499 C7.111,5.527 7.41,6.478 7.902,7.296 C7.088,8.326 5.849,9 4.444,9 C1.989,9 0,6.985 0,4.5 C0,2.015 1.989,0 4.444,0 Z M15.396,1.158 C14.6390601,2.10777327 14.2253412,3.28549757 14.222,4.5 C14.222,5.77 14.672,6.92 15.396,7.842 C14.5911681,8.58314889 13.5380942,8.99624495 12.444,9 C11.039,9 9.801,8.327 8.987,7.296 C8.3528311,6.50157083 8.00509508,5.51649493 8,4.5 C8.00524168,3.48383485 8.35297386,2.49912213 8.987,1.705 C9.8,0.673 11.039,0 12.444,0 C13.5380942,0.00375505408 14.5911681,0.416851113 15.396,1.158 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPal);
export default __webpack_public_path__ + "static/media/pal.3fb594aafb1bcc24e3981159ee2f2095.svg";
export { ForwardRef as ReactComponent };